import { post, get, patch, put } from "./http";
import baseURL from "./base";
export default {
    patch (data) {
        return patch(`${baseURL}xxx`, data);
    },
    put (data) {
        return put(`${baseURL}xxx`, data);
    },
    post (data) {
        return post(`${baseURL}xxx`, data);
    },
    // 资源
    resources (data) {
        return get(`https://bookbar.tsgyun.com/res/nav?platform=1`, data);
    },

    // 检索接口
    searchAll (type, data) {
        return get(`${baseURL.resourceURL}${type}/search`, data);
    },
    // 查看pdf
    download (url, data) {
        if (url == 'cnki') {
            return get(`${baseURL.resourceURL}${url}/download?url=` + data);
        } else {
            return get(`${baseURL.resourceURL}${url}/download`, data);
        }
    },

    /* WOS */
    wosSearch (data) {
        return get(`${baseURL.resourceURL}wos/search`, data);
    },
    wosRefine (data) {
        return get(`${baseURL.resourceURL}wos/refine`, data);
    },
    wosNextPage (data) {
        return get(`${baseURL.resourceURL}wos/next-page`, data);
    },
    wosDetail (data) {
        return get(`${baseURL.resourceURL}wos/detail`, data);
    },
    fulltextApplyDo (url, data) {
        return get(url, data);
    },

    /* chkd，cnki */
    search (url, data) {
        // 检索接口
        return get(`${baseURL.resourceURL}` + url + `/search`, data);
    },
    refine (url, data) {
        return get(`${baseURL.resourceURL}` + url + `/refine`, data);
    },
    facet (url, data) {
        return get(`${baseURL.resourceURL}` + url + `/facet`, data);
    },

    /* sinomed */
    sinomedSearch (data) {
        return get(`${baseURL.resourceURL}sinomed/search`, data);
    },
    sinomedFacet (data) {
        return get(`${baseURL.resourceURL}sinomed/facet`, data);
    },
    /* scopus */
    scopusSearch (data) {
        return get(`${baseURL.resourceURL}scopus/search`, data);
    },

    /* 单位 */
    getjobloginins (data) {
        return post(`${baseURL.userURL}user/getjobloginins`, data);
    },
    /* 验证码 */
    captcha (data) {
        return get(`${baseURL.userURL}user/captchatoken?type=login&${new Date().getTime()}`, data);
    },
    /* 登录 */
    login (data) {
        return post(`${baseURL.userURL}user/login`, data);
    },
};
